import styles from "../ProductImage/productImage.module.scss";
import Image from "next/image";
import Srcset from "../common/Srcset";
import VideoComp from "../VideoComp";
import Slider from "react-slick";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SlickSlider from "../SlickCarousalPDP";
/*
This component will be used to display the product images.
*/
export default function ProductImage({ productImage, device, toggleModal }) {
  //set loader for image for image optimization
  const myLoader = ({ src, width, height, quality }) => {
    return `${src}?w=${width}&h=${height}&q=${quality || 75}`;
  };
  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    horizontalSwiping: true,
    vertical: false,
    dots: false,
  };
  if (productImage) {
    const arr = productImage.map((ele, index) => {
      if (ele.type && ele.type === "video") {
        let videoSrc = "";
        Object.values(ele).forEach((src, index) => {
          if (index == 0) {
            videoSrc=src.url;
          }
        })
        return (
          <VideoComp vidSrc={videoSrc} autoPlay={false}/>
        )
      } else {
        return (
          <Srcset
            id={index}
            loader={myLoader}
            key={index + "images"}
            src={ele.url}
            alt={ele.alt}
            data-title={ele.title}
            className={`${styles.image}`}
            onClick={toggleModal}
            role="button"
            width="100%"
            height="100%"
          />
        );
      }
    });
    let display = "";
    if (device === "mobile") {
      display = (
        <div className="slider-wrapper">
          <Slider {...settings}>
            {arr.map((slide, index) => {
              return <div key={index}>{slide}</div>;
            })}
          </Slider>
        </div>
      );
    }else if (device === "desktop" && productImage.length > 1) {
      display = (        
        <div className="slider-wrapper" id={productImage.length}>
           <SlickSlider productImage={productImage} toggleModal={toggleModal}/>
        </div>
      );
    } else {
      display = arr.map((slide, index) => {
        return (
          <div className={`${styles.image_pd} tangiblee-ref`} key={index}>
            {slide}
          </div>
        );
      });
    }
    return <>{display}</>;
  }
}
